export const EVENT_DATA_TYPE = 1,
    COMMUNITY_DATA_TYPE = 2

/**
 * Checks if the given event is of type EVENT_DATA_TYPE.
 *
 * @param {any} event - The event to be checked.
 * @return {boolean} Returns true if the event is of type EVENT_DATA_TYPE, false otherwise.
 */
export function isEvent(event) {
    return event.data_type == EVENT_DATA_TYPE;
}

/**
 * Check if the event is of type COMMUNITY_DATA_TYPE.
 *
 * @param {object} event - The event to be checked
 * @return {boolean} Returns true if the event is of type COMMUNITY_DATA_TYPE, false otherwise
 */
export function isCommunity(event) {
    return event.data_type == COMMUNITY_DATA_TYPE;
}

/**
 * Check if an event is an agenda item.
 *
 * @param {Object} event - The event to check.
 * @return {boolean} Returns true if the event is an agenda item, false otherwise.
 */
export function isAgenda(event) {
    return !isEvent(event) && !isCommunity(event) && !!event.agenda_type;
}
